export const createMagnifierIcon = () => {
  const magnifyIcon = document.createElement('div');

  magnifyIcon.className = 'cloudimage-360-magnifier-icon';

  return magnifyIcon;
};
